const data = {
  counterText: 'Seulement quelques places disponibles',
  loading: 'Charger',
  next: 'Continuer',
  previous: 'Précédent',
  smCounterText: 'Places limitées !',
};

export default data;
